import React from "react"
import { Link } from "gatsby"
import { Helmet } from "react-helmet"
import Layout from "../layout"
import { GUIDES } from "../../data/guides"

const SITE_URL = "https://vibrahub.com"

const formatDate = (iso) =>
  new Date(iso).toLocaleDateString("en-GB", { day: "numeric", month: "long", year: "numeric" })

/**
 * Shared shell for long-form guides: page header, article column, related
 * guides and a soft call to action. Content is passed as children.
 */
export default function GuideLayout({ guide, children }) {
  const url = `${SITE_URL}/guides/${guide.slug}/`
  const related = GUIDES.filter((g) => g.slug !== guide.slug)

  const schema = {
    "@context": "https://schema.org",
    "@type": "Article",
    headline: guide.title,
    description: guide.excerpt,
    dateModified: guide.updated,
    datePublished: guide.updated,
    mainEntityOfPage: url,
    author: { "@type": "Organization", name: "VibraHub", url: SITE_URL },
    publisher: { "@type": "Organization", name: "VibraHub", url: SITE_URL },
  }

  return (
    <Layout seo={{ title: guide.title, description: guide.excerpt, article: true }}>
      <Helmet>
        <script type="application/ld+json">{JSON.stringify(schema)}</script>
      </Helmet>

      <div className="breadcrumb-area">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="row breadcrumb_box  align-items-center">
                <div className="col-lg-8 text-center text-lg-left">
                  <h1 className="breadcrumb-title guide-title">{guide.title}</h1>
                </div>
                <div className="col-lg-4">
                  <ul className="breadcrumb-list text-center text-lg-right">
                    <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                    <li className="breadcrumb-item"><Link to="/guides/">Guides</Link></li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="site-wrapper-reveal border-bottom">
        <div className="container section-space--pb_120">
          <div className="row">
            <div className="col-lg-8 mx-auto">
              <p className="guide-meta">Updated {formatDate(guide.updated)} · {guide.readingTime}</p>
              <article className="guide-article">{children}</article>

              <aside className="guide-cta section-space--mt_60">
                <h3>Thinking about a booth for your office?</h3>
                <p>
                  Vibra One is a one-person soundproof booth with light, ventilation and power built in. We ship across the UK and the EU.
                </p>
                <Link to="/vibra-one/" className="text-btn-normal">See Vibra One <i className="icon-arrow-right"></i></Link>
                <span className="guide-cta__sep">or</span>
                <Link to="/virtual-demo/" className="text-btn-normal">Book a virtual demo <i className="icon-arrow-right"></i></Link>
              </aside>
            </div>
          </div>

          <div className="row section-space--mt_60">
            <div className="col-lg-8 mx-auto">
              <h6 className="footer-widget__title mb-20">More guides</h6>
              <ul className="footer-widget__list">
                {related.map((g) => (
                  <li key={g.slug}><Link to={`/guides/${g.slug}/`} className="hover-style-link">{g.title}</Link></li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  )
}
